import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Textarea,
  VStack,
  useColorModeValue,
  Input,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";

const DescriptionSection = ({ descriptionData, consoleType, onUpdate }) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const labelBgColor = useColorModeValue("gray.100", "gray.700");

  const [description, setDescription] = useState({
    jobName1: "",
    jobName2: "",
    comments: "",
    jobType: 1, // 1=Repair, 2=Mod, 3=New Console
  });

  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (descriptionData) {
      setDescription(descriptionData);
      setTabIndex(descriptionData.jobType ? descriptionData.jobType - 1 : 0);
    }
  }, [descriptionData]);

  const handleChange = (field, value) => {
    const updated = { ...description, [field]: value };
    setDescription(updated);
    // Map to uppercase field names for parent
    onUpdate({
      JOB_NAME1: updated.jobName1,
      JOB_NAME2: updated.jobName2,
      JOB_COMMENTS: updated.comments,
      JOB_TYPE: updated.jobType,
    });
  };

  const handleTabChange = (index) => {
    setTabIndex(index);
    handleChange("jobType", index + 1);
  };

  // Render repair/service options
  const renderRepairOptions = () => {
    return (
      <VStack spacing={2} alignItems='stretch'>
        <FormControl>
          <FormLabel fontSize='xs'>Job Description</FormLabel>
          <Input
            size='sm'
            value={description.jobName1 || ""}
            onChange={(e) => handleChange("jobName1", e.target.value)}
            placeholder='Main job description'
          />
        </FormControl>
        <FormControl>
          <FormLabel fontSize='xs'>Additional Details</FormLabel>
          <Input
            size='sm'
            value={description.jobName2 || ""}
            onChange={(e) => handleChange("jobName2", e.target.value)}
            placeholder='Additional job details'
          />
        </FormControl>
      </VStack>
    );
  };

  // Render mod options
  const renderModOptions = () => {
    return (
      <VStack spacing={2} alignItems='stretch'>
        <FormControl>
          <FormLabel fontSize='xs'>Modification Type</FormLabel>
          <Input
            size='sm'
            value={description.jobName1 || ""}
            onChange={(e) => handleChange("jobName1", e.target.value)}
            placeholder='e.g., SSD Upgrade, Custom Shell'
          />
        </FormControl>
        <FormControl>
          <FormLabel fontSize='xs'>Modification Details</FormLabel>
          <Input
            size='sm'
            value={description.jobName2 || ""}
            onChange={(e) => handleChange("jobName2", e.target.value)}
            placeholder='Additional modification details'
          />
        </FormControl>
      </VStack>
    );
  };

  // Render new console sale options
  const renderNewConsoleOptions = () => {
    return (
      <VStack spacing={2} alignItems='stretch'>
        <FormControl>
          <FormLabel fontSize='xs'>Console Package</FormLabel>
          <Input
            size='sm'
            value={description.jobName1 || ""}
            onChange={(e) => handleChange("jobName1", e.target.value)}
            placeholder='e.g., PS5 Console Bundle'
          />
        </FormControl>
        <FormControl>
          <FormLabel fontSize='xs'>Package Contents</FormLabel>
          <Input
            size='sm'
            value={description.jobName2 || ""}
            onChange={(e) => handleChange("jobName2", e.target.value)}
            placeholder="What's included in the package"
          />
        </FormControl>
      </VStack>
    );
  };

  return (
    <Box bg={bgColor} p={3} borderRadius='md' border='1px' borderColor={borderColor} height='100%'>
      <Heading size='sm' bg={labelBgColor} p={2} borderRadius='md' mb={3}>
        Job Description
      </Heading>

      <VStack spacing={3} alignItems='stretch'>
        <Tabs index={tabIndex} onChange={handleTabChange} colorScheme='blue' size='sm'>
          <TabList>
            <Tab>Repair/Service</Tab>
            <Tab>Modification</Tab>
            <Tab>New Console</Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={0} pt={2}>
              {renderRepairOptions()}
            </TabPanel>
            <TabPanel p={0} pt={2}>
              {renderModOptions()}
            </TabPanel>
            <TabPanel p={0} pt={2}>
              {renderNewConsoleOptions()}
            </TabPanel>
          </TabPanels>
        </Tabs>

        <FormControl>
          <FormLabel fontSize='xs'>Comments / Notes</FormLabel>
          <Textarea
            size='sm'
            value={description.comments || ""}
            onChange={(e) => handleChange("comments", e.target.value)}
            placeholder='Additional comments or notes about the job'
            rows={4}
          />
        </FormControl>
      </VStack>
    </Box>
  );
};

export default DescriptionSection;
